<style>
    html {
        height: 100%;
    }

    body {
        font-family: 'Roboto', sans-serif;
        color: #4a4a4a;
        width: 100%;
        height: 100%;
    }

    .logo-zone {
        background-color: #ffffff;
        height: 100%;
        vertical-align: middle;
    }

    .mensaje-zone {
        height: 100%;
        vertical-align: middle;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .bg-celeste {
        background-color: #ff6c2e;
    }

    .mensaje-zone p,
    .mensaje-zone h1,
    .mensaje-zone h2,
    .mensaje-zone h3,
    .mensaje-zone h4 {
        color: #ffffff;
    }

    .fl-l {
        float: left;
    }

    .alto-total {
        height: 100%;
    }

    .logo-zone,
    .mensaje-zone {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    a {
        color: #ffffff;
    }

    a:hover {
        color: #ff6c2e;
    }

    .txt-error {
        font-size: 82px;
        font-weight: 200;
        line-height: 86px;
        margin-right: 30px;
        border-right: 1px #fff solid;
        padding-right: 30px;
    }

    .p-error {
        font-size: 28px;
        line-height: 30px;
        font-weight: 300;
    }
</style>
<div class="col-12 alto-total col-sm-12">
    <div class="row alto-total">
        <div class="col-6 fl-l alto-total col-sm-6">
            <div class="logo-zone text-center">
                <img src="{{data.imgUrl}}" width="auto" height="auto">
                <p class="p-error">{{data.otherText}}</p>
            </div>
        </div>
        <div class="col-6 fl-l alto-total bg-celeste col-sm-6">
            <div class="mensaje-zone text-left">
                <h1 class="txt-error">Error <b>{{data.numberError}}</b></h1>
                <p class="p-error">{{data.longText}}</p>
            </div>
        </div>
    </div>
</div>